import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobileOrTablet: undefined,
    isMobileOrPortrait: undefined,
  },
  mutations: {
    updateIsMobileOrTablet(state, flag) {
      state.isMobileOrTablet = flag;
      window.isMobileOrTablet = flag;
    },
    updateIsMobileOrPortrait(state, flag) {
      state.isMobileOrPortrait = flag;
    },

    pageHidden(state) {
      let offset = window.pageYOffset;
      document.documentElement.classList.add('hidden');
      state.windowOffset = offset;
      state.pageIsHidden = true;
      document.querySelector('#app').style.cssText = 'position: fixed;top: -' + offset + 'px';
    },
    pageDelHidden(state) {
      document.documentElement.classList.remove('hidden');
      state.pageIsHidden = false;
      document.querySelector('#app').style.cssText = 'position: relative;  top: 0px';
      window.scrollTo(0, state.windowOffset);
    },
  },
  actions: {
  },
  modules: {
  }
})
